import React, { useState } from "react";
import { project } from "../Data/data.js";
import { AiOutlineLink, AiFillGithub } from "react-icons/ai";
import ShowModal from "./ShowModal.jsx";
const Project = () => {
  const [array, setArray] = useState(0);
  const [showModal, setShowModal] = useState(false);
  return (
    <div
      id="project"
      className="justify-center w-[100vw] flex flex-col items-center py-8 pb-[11.3rem]  bg-gradient-to-r from-purple-500 via-blue-500 to-sky-500"
    >
      {/* Head  */}
      <div className="my-20 text-4xl text-center text-white hover:animate-pulse">
        Projects
        <div className="bg-white h-2 w-48 mt-2" />
      </div>
      {/* All Projects */}
      <div className="allProjects flex flex-wrap gap-20 w-[80vw] justify-center items-center">
        {showModal && (
          <ShowModal
            arrayNum={array}
            closeModal={() => {
              setShowModal(false);
            }}
          />
        )}
        {project.map((items) => (
          <div
            id={items.name}
            className="h-auto w-96 hover:shadow-gray-200 hover:shadow-2xl bg-white p-4 text-2xl font-light text-center shadow-lg shadow-gray-500 duration-500 hover:cursor-pointer rounded-2xl flex flex-col justify-center items-center"
          >
            <div
              className="flex flex-col justify-center items-center"
              onClick={() => {
                setArray(items.num);
                setShowModal(true);
              }}
            >
              <div className="head font-bold text-3xl text-blue-400 my-4 border-b-4">
                {items.name}
              </div>
              <img
                src={items.image}
                alt=""
                className="h-48 w-80 my-4 rounded-lg shadow-sm shadow-blue-200"
              />
            </div>
            <div className="desc">
              {/* <p className="mainDesc font-extralight text-lg -tracking-wider">
                {items.desc}
              </p> */}
              <p className="link text-3xl flex flex-row justify-center ">
                <a
                  href={`${items.link}`}
                  target="_blank"
                  rel="noreferrer"
                  className="px-1 mt-4 hover:animate-pulse hover:scale-[1.2] duration-500"
                >
                  <AiOutlineLink />
                </a>
                <a
                  href={`${items.github}`}
                  target="_blank"
                  rel="noreferrer"
                  className="px-1 mt-4 hover:animate-pulse hover:scale-[1.2] duration-500"
                >
                  <AiFillGithub />
                </a>
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Project;
